// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__2fRyN","grow0":"Button_grow0__nZ-8R","grow1":"Button_grow1__1Pg9i"};